export class DateTimeRounder {
    private _tempDate: Date;

    constructor(
        public date: Date,
        public direction: 'up' | 'down',
        /** Default [[TickIndicator]] for [[DateTimeRounder.round]] method */
        public tickIndicator: OLO.Types.TICK_INDICATOR = 15,
    ) {
        this._tempDate = new Date(date.getTime());
    }

    private _firstAvailableFullHour(initialDate: Date): Date {
        return new Date(new Date(initialDate.getTime() + 1000 * 60 * 60).setMinutes(0));
    }

    /**
     * Based on [[tickIndicator]] value, selects proper rounding method
     * @returns {Date}
     */
    public round(): Date | never {
        switch (this.tickIndicator) {
            case 10:
                return this.roundByTen();
            case 15:
                return this.roundByQuarter();
            case 30:
                return this.roundByHalfHour();
            case 60:
            case 120:
                return this.roundByHour();
            default:
                throw new Error(`Invalid nextTick indicator value: ${this.tickIndicator}. Allowed values: 10, 15, 30, 60.`);
        }
    }

    public roundByTen(): Date {
        const minutes = this._tempDate.getMinutes();

        let newMinutes: number;
        switch (true) {
            case minutes < 10:
                newMinutes = this.direction === 'up' ? 10 : 0;
                break;
            case minutes >= 10 && minutes < 20:
                newMinutes = this.direction === 'up' ? 20 : 10;
                break;
            case minutes >= 20 && minutes < 30:
                newMinutes = this.direction === 'up' ? 30 : 20;
                break;

            case minutes >= 30 && minutes < 40:
                newMinutes = this.direction === 'up' ? 40 : 30;
                break;

            case minutes >= 40 && minutes < 50:
                newMinutes = this.direction === 'up' ? 50 : 40;
                break;

            case minutes >= 50:
                newMinutes = this.direction === 'up' ? 60 : 50;
        }

        if (newMinutes === 60) {
            return this._firstAvailableFullHour(this._tempDate);
        }

        return new Date(this._tempDate.setMinutes(newMinutes));
    }

    public roundByQuarter(): Date {
        const minutes = this._tempDate.getMinutes();

        let newMinutes: number;
        switch (true) {
            case minutes < 15:
                newMinutes = this.direction === 'up' ? 15 : 0;
                break;

            case minutes >= 15 && minutes < 30:
                newMinutes = this.direction === 'up' ? 30 : 15;
                break;

            case minutes >= 30 && minutes < 45:
                newMinutes = this.direction === 'up' ? 45 : 30;
                break;

            case minutes >= 45:
                newMinutes = this.direction === 'up' ? 60 : 45;
                break;
        }

        if (newMinutes === 60) {
            return this._firstAvailableFullHour(this._tempDate);
        }

        return new Date(this._tempDate.setMinutes(newMinutes));
    }

    public roundByHalfHour(): Date {
        const minutes = this._tempDate.getMinutes();

        let newMinutes: number;
        switch (true) {
            case minutes === 0:
                newMinutes = 0;
                break;
            case minutes === 30:
                newMinutes = 30;
                break;
            case minutes < 30:
                newMinutes = this.direction === 'up' ? 30 : 0;
                break;

            case minutes > 30:
                newMinutes = this.direction === 'up' ? 60 : 30;
                break;
        }

        if (newMinutes === 60) {
            return this._firstAvailableFullHour(this._tempDate);
        }

        return new Date(this._tempDate.setMinutes(newMinutes));
    }

    public roundByHour(): Date {
        const minutes = this._tempDate.getMinutes();

        let newMinutes: number;
        switch (true) {
            case minutes === 0:
                newMinutes = 0;
                break;
            case minutes < 30:
                newMinutes = this.direction === 'up' ? 60 : 0;
                break;

            case minutes >= 30:
                newMinutes = this.direction === 'up' ? 60 : 0;
                break;
        }

        return new Date(this._tempDate.setMinutes(newMinutes));
    }
}
